import React from "react"
import {FieldType} from "../../../../../../field-type";
import FieldsFactory from "../../../../../../fields-factory";
import FieldFormElementView from "../../../../../../render/form-elemnent-view";
import FieldPopover_InlineEditable from "../../../../../popover/render/inline-editable";
import FieldPopover_FormComponent from "../../../../../popover/components/form/form-component";
import FieldTimeReported from "../../../time-spent";
import FieldTimeReported_MyTimeAddFromPopover from "../../../render/my-time/my-time-add-from-popover";

const debug = false
// const debug = "FieldTimeReported_CustomTime"

type Props = {
    onSubmit?   : callback,
    model       : any,
    parent      : FieldPopover_FormComponent | FieldPopover_InlineEditable | FieldTimeReported_MyTimeAddFromPopover
    field       : FieldTimeReported
}

export default function FieldTimeReported_CustomTime(props:Props) {


    const fieldCurrentValue = FieldsFactory.get({
        type        : FieldType.TIME_DURATION,
        fieldId     : props.field.fieldId,
        placeholder : props.field.placeholderValueExample,
        isRequired  : true,
    })

    const onValueChange = (value: number) => {
        debug && console.log(debug, 'onValueChange', value)

        if (!props.field.isValueValid(value)) {
            // console.log("onValueChange - INCORRECT VALUE -  do nothing")
            return
        }

        props.parent.onValueChange(value, false)
    }

    const onEnter = (value:number) => {
        debug && console.log(debug, "onEnter", value)

        if (!props.field.isValueValid(value)) {
            // console.log("INCORRECT VALUE onEnter -  do nothing")
            props.parent.hidePopover()
            return
        }

        props.parent.onValueChange(value, true)
    }

    return (
        <div className="w-100-percent">
            <FieldFormElementView className = "h-36 w-100-percent min-w-250"
                                  field     = {fieldCurrentValue}
                                  model     = {props.model}
                                  onEnter   = {onEnter}
                                  options   = {{autofocus: true}}
                                  onChange  = {onValueChange}/>
        </div>
    )
}



